export default __webpack_public_path__ + "static/media/socketiodrawing.da33337b.png";